import { render, staticRenderFns } from "./pg_product.vue?vue&type=template&id=5e82fd76"
import script from "./pg_product.vue?vue&type=script&lang=js"
export * from "./pg_product.vue?vue&type=script&lang=js"
import style0 from "./pg_product.vue?vue&type=style&index=0&id=5e82fd76&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports